export default __webpack_public_path__ + "static/media/icon-magnifying-glass.5e6c03d4.svg";